import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import { ErrorGeneral } from "../componentes/oferta/ErrorGeneral";
import { OfertaMain } from "../componentes/oferta/OfertaMain";
import { Abajo } from "../componentes/pago/Abajo";
import { LoadPago } from "../componentes/pago/LoadPago";
import { Payment } from "../componentes/pago/Payment";
import { StoreLocator } from "../componentes/store/StoreLocator";
import { Recargas } from "../componentes/recargas/Recargas";
import { LoadPayment } from "../componentes/recargas/LoadPayment";
import { Recibo } from "../componentes/recargas/Recibo";
import { AbajoRec } from "../componentes/recargas/AbajoRec";
import { ErrorGralRec } from "../componentes/recargas/ErrorGralRec";


export const AppRouter = () => {
    return (
        <Router>
            <div>
                <Switch>
                    <Route exact path="/locator" component={ StoreLocator} />
                    <Route exact path="/payment" component={ Payment} />
                    <Route exact path="/load" component={ LoadPago} />
                    <Route exact path="/conexionpago" component={ LoadPayment} />
                    <Route exact path="/error" component={ ErrorGeneral} />
                    <Route exact path="/errorrec" component={ ErrorGralRec} />
                    <Route exact path="/nopay" component={ Abajo} />
                    <Route exact path="/nopayrec" component={ AbajoRec} />
                    <Route exact path="/recarga" component={ Recargas} />
                    <Route exact path="/recargas" component={ Recargas} />
                    <Route exact path="/recibopago" component={ Recibo} />
                    <Route  path="/" component={ OfertaMain} />
                </Switch>
            </div>
        </Router>
    )
}
